// extracted by mini-css-extract-plugin
export var videoContainer = "_iw-0";
export var videoIframe = "_iw-3";
export var videoLink = "_iw-1";
export var videoOverlay = "_iw-4";
export var videoOverlayText = "_iw-5";
export var videoWrapper = "_iw-2";